import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrandService {
  /**
   * Returns true when current URL contains 'healthpluspeople'
   * (case-insensitive). Safe on server: returns false.
   */
  isHealthPlusPeople(): boolean {
    if (typeof window === 'undefined' || !window?.location?.href) {
      return false;
    }
    return window.location.href.toLowerCase().includes('healthpluspeople');
  }
}